// ==========================
// Date / Time
// ==========================
export enum DayOfWeek {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday'
}

// ==========================
// Deals / Boosts
// ==========================
export interface HappyHourDeal {
  id: string;
  item: string;
  price: string;
  category: 'Food' | 'Beer' | 'Wine' | 'Cocktail';
  isFeatured?: boolean;
  isGroupDeal?: boolean;
}

export interface FlashBoost {
  id: string;
  message: string;
  timestamp: string;
  durationHours: number;
  active: boolean;
  reachCount?: number;
}

// ==========================
// Core Event / Venue
// ==========================
export interface SpecialEvent {
  id: string;
  name: string;
  venueName: string;

  // Location
  address: string;              // legacy combined string
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;

  // Optional geo for nearby search
  lat?: number;
  lng?: number;

  // Web / socials
  website?: string;
  facebook?: string;
  instagram?: string;
  xHandle?: string;

  rating: number;

  // Media
  imageUrl: string;
  logoUrl?: string;
  galleryImages?: string[];

  // Time / schedule
  startTime: string;
  endTime: string;
  endDate?: string | null; // null = indefinite
  days: DayOfWeek[];

  // Content
  deals: HappyHourDeal[];
  tags: string[];
  notes?: string;

  // Business / monetization
  plan?: 'partner';
  listing_status?: 'demo' | 'live';
  isSpotlight?: boolean;
  activeBoost?: FlashBoost | null;

  // Verification
  isVerified?: boolean;
  is_verified?: boolean;

  // Ownership
  ownerId?: string;
  venueId?: string;
  isSample?: boolean;
}

// ==========================
// Merchant identity
// ==========================
export interface VenueIdentity {
  venueName: string;
  address: string; // legacy
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
  website: string;
  facebook: string;
  instagram: string;
  xHandle: string;
  logoUrl: string;
  mainImageUrl: string;
  galleryImages: string[];
  isVerified?: boolean;
  is_verified?: boolean;
}

// ==========================
// App State
// ==========================
export type SubscriptionPlan = 'partner' | null;

export type ViewState =
  | 'landing'
  | 'results'
  | 'merchant-auth'
  | 'payment'
  | 'merchant-portal'
  | 'special-editor'
  | 'venue-page'
  | 'privacy-policy'
  | 'terms-of-service'
  | "thank-you";

export interface Coordinates {
  lat: number;
  lng: number;
}

// ==========================
// Search Params
// ==========================
export interface SearchParams {
  // Time filtering
  date: string;
  time: string;

  // Smart location search input and display label
  location: string;
  locationLabel?: string;

  // Legacy city selection retained so older history state does not break.
  selectedCities?: string[];

  // Category / vibe filters
  category?: string;
  vibe?: string;

  // Favorites toggle
  showFavoritesOnly?: boolean;

  // Resolved search center for radius filtering
  coords?: Coordinates | null;
  radiusMiles?: 5 | 10 | 25 | number;

  // User-facing location validation message
  locationError?: string | null;
}
